import React from 'react';
import BibleVerse from '../utils/BibleVerse';

function Gospel(props) {
  return (
    <div>
      <h3>God </h3>
      <p>The Bible teaches us that there is only one true, eternal, and holy God. He is the all-powerful Creator and just Judge to whom we are all accountable:</p>
      <p>"... without faith it is impossible to please Him, for he who comes to God must believe that He is, and that He is a rewarder of those who diligently seek Him." <BibleVerse reference="HEB.11.6" text="Hebrews 11:6" /></p>

      <h3>Man</h3>
      <p>From the Bible we learn that we are made by God, and that He deserves our full obedience:</p>
      <p>"... the LORD God formed man of the dust of the ground, and breathed into his nostrils the breath of life; and man became a living being." <BibleVerse reference="GEN.2.7" text="Genesis 2:7" /></p>

      <h3>Sin</h3>
      <p>From the Bible we learn that we have all sinned against God and deserve His righteous punishment:</p>
      <p>"... all have sinned and fall short of the glory of God." <BibleVerse reference="ROM.3.23" text="Romans 3:23" /></p>

      <h3>Death</h3>
      <p>From the Bible we learn that we are facing God's judgement and cannot escape it on our own:</p>
      <p>"... it is appointed for men to die once, but after this the judgement." <BibleVerse reference="HEB.9.27" text="Hebrews 9:27" /></p>

      <h3>Christ</h3>
      <p>From the Bible we learn that Jesus Christ is the perfect Son of God AND the perfect Son of Man, the only way to eternal life:</p>
      <p>"Jesus said to him [Thomas], 'I AM the Way, the Truth, and the Life. No one comes to the Father except through Me.'" <BibleVerse reference="JHN.14.6" text="John 14:6" /></p>

      <h3>Cross</h3>
      <p>From the Bible we learn that Jesus Christ, God's Son, died physically for our sins and rose from the dead to rescue us from death (God's eternal wrath) and give us eternal life:</p>
      <p>"[He] Himself bore our sins in His own body on the tree, that we, having died to sins, might live for righteousness - by whose stripes you were healed." <BibleVerse reference="1PE.2.24" text="1 Peter 2:24" /></p>

      <h3>Faith </h3>
      <p>From the Bible we learn that we must trust in Jesus' death on the cross as the only satisfactory payment for our sins, as we abandon our trust in other things that we formerly relied upon to save us:</p>
      <p>"... by grace you have been saved through faith, and that not of yourselves; it is the gift of God, not of works, lest anyone should boast." <BibleVerse reference="EPH.2.8-9" text="Ephesians 2:8–9" /></p>

      <h3>Life</h3>
      <p>From the Bible we learn that Jesus alone has power over death and that He gives eternal life to those who trust solely in Him for the forgiveness of sins:</p>
      <p>"Jesus said..., 'I AM the resurrection and the life. He who believes in Me, though he may die, he shall live. And whoever lives and believes in Me shall never die. Do you believe this?'" <BibleVerse reference="JHN.11.25-26" text="John 11:25-26" /></p>
      <p>"... if you confess with your mouth that Jesus is Lord [God] and believe in your heart that God [the Father] raised Him from the dead, you will be saved. For with the heart one believes and is justified, and with the mouth one confesses and is saved." <BibleVerse reference="ROM.10.9-10" text="Romans 10:9–10" /></p>
    </div>
  )
}

export default Gospel;
